import React, { lazy, Suspense } from 'react'
import { Switch, Route } from 'react-router-dom'
import './App.css'
import LinearProgress from '@material-ui/core/LinearProgress'

import RigvDisclaimerAndroid from './essential/RigvDisclaimerAndroid'
import SchoolDisclaimerAndroid from './essential/SchoolDisclaimerAndroid'
import FitterDisclaimerAndroid from './essential/FitterDisclaimerAndroid'
import InspectorDisclaimerAndroid from './essential/InspectorDisclaimerAndroid'
import InspectorDisclaimerIos from './essential/InspectorDisclaimerIos'
import RigvDisclaimerIos from './essential/RigvDisclaimerIos'
import SchoolDisclaimerIos from './essential/SchoolDisclaimerIos'
import FitterDisclaimerIos from './essential/FitterDisclaimerIos'
import Home from './essential/Home'
import GreenIOTGetLevelAndroid from './essential/GreenIOTGetLevelAndroid'
import GreenIOTGetLevelIos from './essential/GreenIOTGetLevelIos'
import RsbDisclaimerAndroid from './essential/RsbDisclaimerAndroid'
import RsbDisclaimerIos from './essential/RsbDisclaimerIos'
import IotrixDisclaimerAndroid from './essential/IotrixDisclaimerAndroid'
import IotrixDisclaimerIos from './essential/IotrixDisclaimerIos'
import BilltraceCAPDisclaimerAndroid from './essential/Billtrace/BilltraceCAPDisclaimerAndroid'
import BilltraceCAPDisclaimerIOS from './essential/Billtrace/BilltraceCAPDisclaimerIOS'
import CorporateRigvAndroidDisclaimer from './essential/CorporateRigvAndroidDisclaimer'
import CorporateRigvIosDisclaimer from './essential/CorporateRigvIosDisclaimer'
import ChildSafetyRigvAndroidDisclaimer from './essential/ChildSafetyRigvAndroidDisclaimer'
import ChildSafetyRigvIosDisclaimer from './essential/ChildSafetyRigvIosDisclaimer'
import ChildSafetyRigDisclaimer from './essential/ChildSafetyRigvDisclamer'
// const IOSDesclaimer = lazy(() => import('./essential/IosDisclaimer'))
// const AndroidDesclaimer = lazy(() => import('./essential/AndroidDisclaimer'))

function App() {
  return (
    <div className="App">
      <Suspense fallback={<LinearProgress />}>
        <Switch>
          {/* rigv */}
          <Route
            exact
            path="/Rigv-disclaimerAnd"
            name="RigvDisclaimerAndroid"
            component={RigvDisclaimerAndroid}
          />
          <Route
            exact
            path="/Rigv-disclaimerIos"
            name="RigvDisclaimerIos"
            component={RigvDisclaimerIos}
          />
          {/* school */}
          <Route
            exact
            path="/RigvSchool-disclaimerAnd"
            name="SchoolDisclaimerAndroid"
            component={SchoolDisclaimerAndroid}
          />
          <Route
            exact
            path="/RigvSchool-disclaimerIos"
            name="SchoolDisclaimerIos"
            component={SchoolDisclaimerIos}
          />

          {/* RSB Admin */}
          <Route
            exact
            path="/RSBAdmin-disclaimerAnd"
            name="RsbDisclaimerAndroid"
            component={RsbDisclaimerAndroid}
          />
          <Route
            exact
            path="/RSBAdmin-disclaimerIos"
            name="RsbDisclaimerIos"
            component={RsbDisclaimerIos}
          />

          {/* fitter */}
          <Route
            exact
            path="/RigvFitter-disclaimerAnd"
            name="FitterDisclaimerAndroid"
            component={FitterDisclaimerAndroid}
          />
          <Route
            exact
            path="/RigvFitter-disclaimerIos"
            name="FitterDisclaimerIos"
            component={FitterDisclaimerIos}
          />

          {/* inspector */}
          <Route
            exact
            path="/RigvInspector-disclaimerAnd"
            name="InspectorDisclaimerAndroid"
            component={InspectorDisclaimerAndroid}
          />
          <Route
            exact
            path="/RigvInspector-disclaimerIos"
            name="InspectorDisclaimerIos"
            component={InspectorDisclaimerIos}
          />

          {/* Green IOT Get Level */}
          <Route
            exact
            path="/greeniot-disclaimerAnd"
            name="GetLevelDisclaimerAndroid"
            component={GreenIOTGetLevelAndroid}
          />
          <Route
            exact
            path="/greeniot-disclaimerIos"
            name="GetLevelDisclaimerIos"
            component={GreenIOTGetLevelIos}
          />

        {/* IOTRIX Water Level */}
        <Route
            exact
            path="/iotrix-disclaimerAnd"
            name="IotrixDisclaimerAndroid"
            component={IotrixDisclaimerAndroid}
          />
          <Route
            exact
            path="/iotrix-disclaimerIos"
            name="IotrixDisclaimerIos"
            component={IotrixDisclaimerIos}
          />

          {/* Billtrace CaptainPAD */}
        <Route
            exact
            path="/billtrace-disclaimerAnd"
            name="BilltraceCAPDisclaimerAndroid"
            component={BilltraceCAPDisclaimerAndroid}
          />
          <Route
            exact
            path="/billtrace-disclaimerIos"
            name="BilltraceCAPDisclaimerIOS"
            component={BilltraceCAPDisclaimerIOS}
          />
          {/*  Corporate Rigv  */}
          <Route
            exact
            path="/corporate-disclaimerAnd"
            name="CorporateRigvAndroidDisclaimer"
            component={CorporateRigvAndroidDisclaimer}
          /><Route
          exact
          path="/corporate-disclaimerIos"
          name="CorporateRigvIosDisclaimer"
          component={CorporateRigvIosDisclaimer}
        />
        <Route
          exact
          path="/childSafety-disclaimerAnd"
          name="ChildSafetyRigvAndroidDisclaimer"
          component={ChildSafetyRigvAndroidDisclaimer}
        /><Route
        exact
        path="/childSafety-disclaimerIos"
        name="ChildSafetyRigvIosDisclaimer"
        component={ChildSafetyRigvIosDisclaimer}
      /><Route
      exact
      path="/childSafety-disclaimer"
      name="ChildSafetyRigDisclaimer"
      component={ChildSafetyRigDisclaimer}
    />

          <Route exact path="/" name="Home" component={Home} />
        </Switch>
      </Suspense>
    </div>
  )
}

export default App
